import { get } from './apiClient'

const API_BASE_URL = 'https://api.dipseastories.com'

export type ReviewUsernameType = {
  username: string,
  emoji: string,
  color: string,
  userId: string
}

export type ReviewRatingsType = {
  overall: number,
  voiceActing?: number,
  storyPlot?: number,
  soundDesign?: number
}

export type ReviewContentType = {
  title?: string,
  imageUrl?: string
}

export type TrendingReviewType = {
  id: string,
  userId: string,
  contentId: string,
  contentType: 'chapter' | 'audiobook',
  user: ReviewUsernameType,
  reviewText?: string,
  reviewedAt: number,
  moderationFlag: 'a' | 'f' | 'u',
  favorites: number,
  admin: boolean,
  shareWithOthers?: boolean,
  ratings?: ReviewRatingsType,
  content?: ReviewContentType
}

export type TrendingReviewsPaginationType = {
  limit: number,
  offset: number,
  hasMore: boolean
}

export type TrendingReviewsResponseType = {
  reviews: TrendingReviewType[],
  pagination: TrendingReviewsPaginationType,
  parameters: {
    timeframe: '24h' | '7d' | '30d' | 'all',
    minFavorites: number,
    moderationFlag: 'a' | 'f' | 'u'
  }
}

export type GetTrendingReviewsOptionsType = {
  limit?: number,
  offset?: number,
  timeframe?: '24h' | '7d' | '30d' | 'all',
  minFavorites?: number
}

export type GetChapterReviewsOptionsType = {
  page?: number,
  pageSize?: number
}

export type ChapterReviewsResponseType = {
  favorites: number,
  listens: number,
  reviews: TrendingReviewType[]
}

export async function getTrendingReviews (
  options: GetTrendingReviewsOptionsType = {}
): Promise<TrendingReviewsResponseType> {
  const {
    limit = 20,
    offset = 0,
    timeframe = '7d',
    minFavorites = 5
  } = options

  const params = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
    timeframe,
    minFavorites: String(minFavorites),
    moderationFlag: 'a'
  })

  const url = `${API_BASE_URL}/user-reviews/trending?${params.toString()}`

  return get(url)
}

export async function getChapterReviews (
  chapterId: string,
  options: GetChapterReviewsOptionsType = {}
): Promise<ChapterReviewsResponseType> {
  const {
    page = 1,
    pageSize = 20
  } = options

  const params = new URLSearchParams({
    contentId: chapterId,
    contentType: 'chapter',
    page: String(page),
    pageSize: String(pageSize),
    moderationFlag: 'a'
  })

  const url = `${API_BASE_URL}/user-reviews?${params.toString()}`

  return get(url)
}
